import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDataProvider } from 'react-admin';

import useCustomNotify from 'hooks/useCustomNotify';

import Select from './Select';

const CurrencySelector = ({ name, label, ...rest }) => {
  const dataProvider = useDataProvider();
  const notify = useCustomNotify();
  const [currencies, setCurrencies] = useState([]);

  const getCurrencies = useCallback(async () => {
    try {
      const response = await dataProvider.get('contries');

      setCurrencies(response.data.map((country) => country.currency));
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'An error occurred while loading currencies';
      notify(errorMessage, 'error');
    }
  }, [dataProvider, notify]);

  const options = useMemo(() => {
    return currencies.map((currency) => ({
      value: currency,
      label: currency,
    }));
  }, [currencies]);

  useEffect(() => {
    getCurrencies();
  }, [getCurrencies]);

  return <Select label={label} name={name} options={options} {...rest} />;
};

export default CurrencySelector;
